import React, { useState} from 'react';
import Button from "app/components/CustomButtons/Button.js";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';

export default function DeleteQuoteReason(props) {
    const { reasons, handleDeleteQuoteReasonOK, handleDeleteQuoteReasonClose } = props;

    const [open, setOpen] = useState(true);
    const [selectedReason, setSelectedReason] = useState(null);
    const [reasonNote, setReasonNote] = useState(null);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSelectReason = (event) => {
        if (event.target.value) {
            setSelectedReason(event.target.value);
        }
    };

    const handleReasonNote = (event) => {
        if (event.target.value) {
            setReasonNote(event.target.value);
        }
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} >
                <DialogTitle>Decline Quote Reason</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth>
                        <InputLabel id="reason">Reasons</InputLabel>
                        <Select
                            required
                            labelId="selectedReason"
                            id="selectedReason"
                            value={selectedReason}
                            label="Reasons"
                            size="small"
                            sx={{ marginTop: 1 }}
                            onChange={handleSelectReason}
                            error={!selectedReason}>
                            {reasons.map(reason =>
                                <MenuItem value={reason.quoteLossReasonTypeId}>{reason.description}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <TextField
                        required
                        fullWidth
                        variant="outlined"
                        label="Note"
                        value={reasonNote}
                        onChange={(event) => { handleReasonNote(event.target.value) }}
                        style={{ marginTop: '10px' }}
                        size="small"
                        onBlur={handleReasonNote}
                        error={!reasonNote}
                    />
                </DialogContent>
                <DialogActions>
                    <Button color="purple" onClick={() => handleDeleteQuoteReasonOK({ quoteLossReasonTypeID: selectedReason, reasonForLostQuote: reasonNote })}>OK</Button>
                    <Button color="purple" onClick={handleDeleteQuoteReasonClose}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}